/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function QuotesIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M6 17.5c0-4.125 3.313-7.5 7.5-7.5h1c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-1C11 13 9 15.063 9 17.5v.625c.313-.062.625-.125 1-.125h4c2.188 0 4 1.813 4 4v4c0 2.25-1.812 4-4 4h-4c-2.25 0-4-1.75-4-4v-8.5M22 24v-6.5c0-4.125 3.313-7.5 7.5-7.5h1c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-1C27 13 25 15.063 25 17.5v.625c.313-.062.625-.125 1-.125h4c2.188 0 4 1.813 4 4v4c0 2.25-1.812 4-4 4h-4c-2.25 0-4-1.75-4-4z"/>}
        </IconWrapper>);
}
